import format from 'date-fns/format';
import React, { useEffect } from 'react';
import { color, Box, Card, Drawer, IconButton, Typography, Skeleton } from '@kistech/kis-ui';
import { Grid, Typography as MuiTypography, Box as MuiBox } from '@mui/material';
import { Transaction } from 'store/deliveryLog';
import { useStyles } from '../styled';

export interface PrinterTicketsProps {
  isOpen: boolean;
  onClose: () => void;
  transaction: Transaction | null;
}

export const PrinterTickets = (props: PrinterTicketsProps) => {
  const { isOpen, onClose, transaction } = props;
  const classes = useStyles({ isOpen })();

  const formatOrderTime = (orderTime: string): string =>
    orderTime ? format(new Date(orderTime), 'MMMM dd yyyy hh:mm a') : '';

  useEffect(() => {
    if (!isOpen) onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, transaction]);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} hasBorderRadius>
      <Grid container direction="column" className={classes.drawerContainer}>
        <Grid container direction="row" className={classes.drawerHeaderContainer}>
          <MuiTypography className={classes.drawerHeaderText}>
            Order {transaction ? transaction.orderNumber : <Skeleton width={400} />}
          </MuiTypography>
          <MuiBox className={classes.drawerCloseIcon}>
            <IconButton
              name="exit_circle"
              appearance="transparent"
              size={40}
              onClick={onClose}
              data-testid="ticket-log-x"
            />
          </MuiBox>
        </Grid>
        <Card.Divider color={color.BORDER} />
        <Grid container direction="column">
          {!transaction ? (
            <Grid className={classes.deliverySkeletonContainer}>
              <Skeleton width={600} />
              <Skeleton width={600} />
              <Skeleton width={600} />
              <Skeleton width={600} />
              <Skeleton width={600} />
              <Skeleton width={600} />
              <Skeleton width={600} />
            </Grid>
          ) : (
            <>
              <Grid container direction="column" className={classes.orderTimeContainer}>
                <Grid container direction="row" className={classes.orderTimeBlock}>
                  <Grid item className={classes.kioskDetailsHeader}>
                    <Typography size={16}>Order Time</Typography>
                  </Grid>
                  <Grid item className={classes.kioskDetailsContent}>
                    <Typography size={16}>{formatOrderTime(transaction.orderTime)}</Typography>
                  </Grid>
                </Grid>
                <Card.Divider color={color.BORDER} />
                <Grid container direction="row" className={classes.kioskNameBlock}>
                  <Grid item className={classes.kioskDetailsHeader}>
                    <Typography size={16}>Kiosk</Typography>
                  </Grid>
                  <Grid item className={classes.kioskDetailsContent}>
                    <Typography size={16}>{transaction.kioskName}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Box padding="2 7" fullWidth>
                <Typography size={16}>
                  {transaction.failedTicketCount} ticket(s) were not delivered successfully.
                </Typography>
              </Box>
            </>
          )}
        </Grid>
      </Grid>
    </Drawer>
  );
};
